import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=1a62905c&scoped=true"
import script from "./resource.vue?vue&type=script&lang=ts"
export * from "./resource.vue?vue&type=script&lang=ts"
import style0 from "./resource.vue?vue&type=style&index=0&id=1a62905c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a62905c",
  null
  
)

export default component.exports